// extracted by mini-css-extract-plugin
module.exports = {"dice":"Dice_dice__QkZjb","active":"Dice_active__tj3yb","dice-number":"Dice_dice-number__1aH6D"};